module.exports = __webpack_public_path__ + "assets/media/2.7400bfa9.wav";